import { render, staticRenderFns } from "./SUBJECT.vue?vue&type=template&id=14e5d06a&scoped=true&"
import script from "./SUBJECT.vue?vue&type=script&lang=js&"
export * from "./SUBJECT.vue?vue&type=script&lang=js&"
import style0 from "./SUBJECT.vue?vue&type=style&index=0&id=14e5d06a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e5d06a",
  null
  
)

export default component.exports